import { z } from 'zod';
import { calculateDisplayLength } from '~/utils/calculateDisplayLength';

export const createPortalSchema = z
  .object({
    title: z
      .string()
      .trim()
      .min(1, '表示名を入力してください。')
      .refine(value => calculateDisplayLength(value) <= 20, {
        message: '半角40文字または全角20文字で入力してください。',
      }),
    url: z.string().optional(),
    file: z.instanceof(File).optional(),
    icon_name: z.string().min(1, 'アイコン名を選択してください。'),
    item_type: z.enum(['url', 'file']),
    sort_order: z.number().min(1),
  })
  // URLのバリデーション
  .refine(
    data => {
      if (data.item_type === 'url') {
        return !!data.url && data.url.trim() !== '';
      }
      // item_typeが'url'でない場合は、このバリデーションをスキップ（パス）させる
      return true;
    },
    {
      message: 'URLを入力してください。',
      path: ['url'],
    }
  )
  // ファイルのバリデーション
  .refine(
    data => {
      if (data.item_type === 'file') {
        return data.file instanceof File;
      }
      // item_typeが'file'でない場合は、このバリデーションをスキップ（パス）させる
      return true;
    },
    {
      message: 'ファイルを選択してください。',
      path: ['file'],
    }
  );

export type CreatePortalFormFieldValues = z.infer<typeof createPortalSchema>;
